<template>
  <el-form
    ref="stopTimerForm"
    :model="formData"
    :rules="rules"
  >
    <el-card class="stop-timer" v-loading="stopping">
      <div slot="header">Timer (Running)</div>
      <div>
        <el-form-item>
          <el-button class="full-width" @click="handleTimerStop" type="danger"><i class="fas fa-stop"></i>  STOP TIMER</el-button>
        </el-form-item>

        <el-alert
                v-if="over24Hours"
                title="You have clocked in more then 24 hours ago."
                type="error"
                show-icon>
        </el-alert>



      </div>
      <div slot="footer">
        <el-row :gutter="0" type="flex" justify="space-between">
          <el-col :span="4">
            <h6>Started</h6>
            {{ activeTimeLog.started_at | formatTime('hh:mm a') }}
          </el-col>
          <el-col :span="6">
            <h6>Category</h6>
            {{ activeTimeLog.category.name }}
          </el-col>
          <el-col :span="14">
            <h6>Note</h6>
            {{ activeTimeLog.note }}
          </el-col>
        </el-row>
      </div>
    </el-card>
  </el-form>
</template>

<script>
  import moment from 'moment';
  import { mapActions, mapGetters } from 'vuex';

  import CalendarService from '@/services/calendarService';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'StopTimer',
    props: {
      activeTimeLog: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        formData: {
          stopped_at: '',
        },
        rules: {
          stopped_at: [
            { validator: this.validateStopped, trigger: 'blur' },
          ],
        },
        datePickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
      };
    },
    computed: {
      ...mapGetters('entities/timeLogs', ['stopping']),
      ...mapGetters('entities/users', ['currentUser']),

      over24Hours() {
        const diffParts = CalendarService.calculateTimeDiff(this.activeTimeLog.started_at);
        return diffParts.hours > 24;
      },

      activeNames() {
        return this.over24Hours ? ['more'] : [];
      },

    },
    methods: {
      ...mapActions('entities/timeLogs', ['stopTimer']),
      handleTimerStop() {
        this.$refs.stopTimerForm.validate((valid) => {
          if (valid) {
            this.$confirm('Do you really want to clock out?', 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              title: 'Confirm',
            }).then(() => {
              this.stopTimer(this.formData)
                .then((response) => {
                  if (response.status) {
                    this.clockInOut(this.currentUser.profile.full_name, 'OUT');
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            });
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));

            return false;
          }

          return true;
        });
      },
      validateStopped(rule, value, callback) {
        if (value !== '' && moment(value).isAfter(moment())) {
          callback(new Error('You cannot set stop time in the future'));
        }

        if (this.over24Hours && value === '') {
          callback(new Error('Time log cannot be longer than 24 hours. Please provide custom clock out time.'));
        }

        if (value !== '' && moment(value).isAfter(moment(this.activeTimeLog.started_at).add(24, 'hours'))) {
          callback(new Error('Time log cannot be longer than 24 hours'));
        }

        callback();
      },
      async clockInOut(username, clockstatus) {
        let statusCode;
        let result;
        const formdata = new FormData();
        const msg = `User: ${username} Clock: ${clockstatus}`;

        formdata.append('message', msg);

        const params = new URLSearchParams({
          name: username,
          clock: clockstatus,
        });

        const url = `https://bvapmiult0.execute-api.us-east-1.amazonaws.com/send_message?${params}`;

        const requestOptions = {
          method: 'POST',
          body: formdata,
          redirect: 'follow',
        };

        try {
          const response = await fetch(url, requestOptions);
          await response.json();
          statusCode = response.status;
          showSuccessMessage('You have been clocked out successfully.');
        } catch (error) {
          result = error;
          statusCode = 400;
        }

        const resp = { status: statusCode, body: JSON.stringify(result) };
        return resp;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .full-width{
    font-size: 20px;
    padding: 20px;
    i{
      margin-right: 10px;
    }
  }
  .stop-timer {
    .block-separator {
      margin-bottom: 0;
    }

    .el-collapse{
      margin: -20px 0;
    }

    .time-counter {
      padding: 10px;
      font-size: 48px;
      border: 1px solid #EEE;
      text-align: center;
      display: block;
    }

    .el-alert {
      margin-top: 20px;
    }
  }
  h6{
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/TimerStop.vue